// Bandeau discret : « Ce site est aussi disponible en English — Switch to English ».
// Affiché UNIQUEMENT si le visiteur lit une page française, que la langue de son navigateur est une
// autre langue du site et qu'il n'a encore fait aucun choix. Le message est écrit dans la langue
// proposée. Aucune redirection automatique (choix volontaire : voir docs/multilingue-plan.md, §2).
import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useLang } from './hooks';
import { suggestedLang, dismissSuggestion } from './detect';
import { loadNamespace, makeT } from './store';

export default function LanguageSuggestion() {
  const { lang, setLanguage } = useLang();
  const [dismissed, setDismissed] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const target = dismissed ? null : suggestedLang(lang);

  useEffect(() => {
    let alive = true;
    setLoaded(false);
    if (target) loadNamespace(target, 'common').then(() => { if (alive) setLoaded(true); });
    return () => { alive = false; };
  }, [target]);

  if (!target || !loaded) return null;
  const tt = makeT(target); // texte dans la langue proposée
  return (
    <Box
      role="region"
      lang={target}
      aria-label={tt('common.suggestion.text')}
      sx={{ bgcolor: '#f3efe9', color: '#3a2b2b', textAlign: 'center', py: 0.5, px: 5, position: 'relative', fontSize: '0.9rem' }}
    >
      {tt('common.suggestion.text')}{' '}
      <Button size="small" variant="text" onClick={() => setLanguage(target)} sx={{ fontWeight: 700, textTransform: 'none' }}>
        {tt('common.suggestion.action')}
      </Button>
      <IconButton
        aria-label={tt('common.suggestion.dismiss')}
        size="small"
        onClick={() => { dismissSuggestion(); setDismissed(true); }}
        sx={{ position: 'absolute', top: '50%', right: 6, transform: 'translateY(-50%)' }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  );
}
